import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SelectChangeEvent } from '@mui/material/Select/SelectInput';
import { FormControlProps } from '@mui/material/FormControl/FormControl';

const OPTIONS = [
  { value: -1, label: 'All time' },
  { value: 7, label: 'Last week' },
  { value: 30, label: 'Last month' },
  { value: 180, label: 'Last 6 months' },
  { value: 365, label: 'Last 12 months' },
];

// `hiddenOptions` drops periods a page doesn't offer (by value, e.g. [7] for "Last week").
function DateFilter({
  selectedDate, onChange, formControl, hiddenOptions = [],
}: {
  selectedDate?: number,
  onChange?: (event: SelectChangeEvent<number>, child: React.ReactNode) => void,
  formControl?: FormControlProps,
  hiddenOptions?: number[],
}) {
  return (
    <FormControl variant="outlined" size="small" sx={{ bgcolor: 'white' }} {...formControl}>
      <Select
        id="adoption-date-label"
        value={selectedDate}
        label=""
        onChange={onChange}
        IconComponent={ExpandMoreIcon}
      >
        {OPTIONS.filter((o) => !hiddenOptions.includes(o.value)).map((o) => (
          <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default DateFilter;
